import type { RegistryEntry } from '../types';

// PixVerse C1 / V6 / V5.6：声画同步（影响计费）+ 负向词 + Seed
export const pixverseConfigs: Record<string, RegistryEntry> = {
    ...Object.fromEntries(
        ['pixverse-c1', 'pixverse-v6', 'pixverse-v5.6'].map(id => [id, {
            options: [
                { key: 'generate_audio_switch', label: 'Audio-Visual Sync', type: 'switch', default: true, group: 'basic' },
                { key: 'negative_prompt', label: 'Negative Prompt', type: 'input', group: 'advanced' },
                { key: 'seed', label: 'Seed', type: 'number', min: 0, max: 2147483647, step: 1, group: 'advanced' },
            ],
            toProviderOptions: (ui: Record<string, any>) => ({
                generate_audio_switch: typeof ui.generate_audio_switch === 'boolean' ? ui.generate_audio_switch : true,
                negative_prompt: typeof ui.negative_prompt === 'string' ? ui.negative_prompt : undefined,
                seed: typeof ui.seed === 'number' && Number.isFinite(ui.seed) ? ui.seed : undefined,
            } as unknown as Record<string, Record<string, any>>),
        } satisfies RegistryEntry])
    ),
};
